import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_PORTFOLIO_TARGET_API =
  'INVESTMENT/FETCH_PORTFOLIO_TARGET_API';
const SET_INVESTCORE_PORTFOLIO_TARGET_API =
  'INVESTMENT/SET_PORTFOLIO_TARGET_API';

export const getTargetPortfolioApiCall = createApiCall(
  FETCH_INVESTCORE_PORTFOLIO_TARGET_API,
  ({ user_id }) => ({
    endpoint: `/api/admin/portfolios/${user_id}/target`,
    method: 'GET',
  })
);

export const setTargetPortfolioApiCall = createApiCall(
  SET_INVESTCORE_PORTFOLIO_TARGET_API,
  ({ user_id, items }) => ({
    endpoint: `/api/admin/portfolios/${user_id}/target`,
    method: 'PUT',
    body: { items },
  })
);

export default getTargetPortfolioApiCall;
